<script>
  import { onDestroy, onMount } from 'svelte';
  import { changeToken } from '../../../Api';
  import { api } from '../../../helpers';

  import { _ } from 'svelte-i18n';

  import CuratorsFilters from '../../custom/Curators/CuratorsFilters.svelte';
  import IniniteScroll from '../../custom/IniniteScroll.svelte';
	import GeneralLayout from './../../layouts/GeneralLayout.svelte';
  import Card from './components/Card.svelte';
  import Loader from '../../custom/Loader.svelte';
  import NoItemsBanner from '../../custom/NoItemsBanner.svelte';
  import {flowId, ordering} from "../../stores";


  let items = [];
  let pagination = null;
  let isShowLoader = true;
  let isHaveItems = false;

  const getItems = async (page = 1) => {
    let path = `/api/v1/publication/topic/list/?page=${page}`;

    if ($flowId) {
      path += `&flows=${$flowId}`;
    }

    if ($ordering) {
      path += `&ordering=${$ordering}`;
    }

    const response = await api(path);

    if (!response.ok) {
      changeToken(response);
      return;
    }

    const data = await response.json();

    items = [...items, ...data.results];
    pagination = data.pagination;
  }

  // Фильтрация по потокам
  const filterNewsByFlow = async ({ id }) => {
    flowId.set(id);

    items = [];

    await getItems();
  };

  const filterNewsByOrdering = async ({ value }) => {
    ordering.set(value);

    items = [];

    await getItems();
  }
  
  const changeNews = async (e) => {
    const type = e.detail.type;
    const option = e.detail.option;

    if (type === 'ordering') {
      filterNewsByOrdering(option);
    }

    if (type === 'flow') {
      filterNewsByFlow(option);
    }
  }

  onMount(async () => {
    await getItems();
    isShowLoader = false;
    isHaveItems = !!items.length;
  });
  
  onDestroy(() => {
    flowId.set(null);
    ordering.set('');
  });
</script>

<GeneralLayout>
  {#if isHaveItems}
    <CuratorsFilters on:change={changeNews} />
  {/if}
  
  {#if items.length}
    {#each items as item }
      <Card {item} />
    {/each}
  {/if}

  {#if isShowLoader}
    <div class="flex justify-center">
      <Loader />
    </div>
  {/if}

  {#if !isShowLoader && !isHaveItems}
    <NoItemsBanner 
      title="{$_('nothingToSeeHere')}"
      subtitle="{$_('contentComingSoon')}"
      background="/static/no-items.jpeg" 
    />
  {/if}
</GeneralLayout>

{#if pagination}
  <IniniteScroll
    hasNext={pagination.has_next}
    loading={isShowLoader}
    on:load={async () => {
      isShowLoader = true;
      await getItems(pagination.next_page_number);
      isShowLoader = false;
    }}
  />
{/if}